<template>
  <router-view />
</template>

<script setup>
import { useEnumStore } from 'stores/enum-store.js'

const enumStore = useEnumStore()

enumStore.ensureLoadEnum('PhoneType')
enumStore.ensureLoadEnum('LinkType')
</script>
